import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import * as textConfiguration from 'src/assets/branding/text-branding/static-text-configuration.json';

@Component({
  selector: 'app-under-development',
  templateUrl: './under-development.component.html',
  styleUrls: ['./under-development.component.scss']
})
export class UnderDevelopmentComponent {

  staticText: any = (textConfiguration as any).default;

  constructor(
    private _authService: AuthService,
     private _router: Router

  ) { }
  
  goBack() {
    this._router.navigate(['/'])
  }
}
